export default "__VITE_ASSET__D$Je4npg__"